import { render, staticRenderFns } from "./TheLoading.vue?vue&type=template&id=e6274e80&scoped=true"
import script from "./TheLoading.vue?vue&type=script&lang=js"
export * from "./TheLoading.vue?vue&type=script&lang=js"
import style0 from "./TheLoading.vue?vue&type=style&index=0&id=e6274e80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6274e80",
  null
  
)

export default component.exports